import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';
import type { Order } from 'entities/Order/model/types/OrderSchema';

interface AddCustomListToOrderParams {
    listId: string;
    orderId: string;
    listCount?: number;
}

export const addCustomListToOrder = createAsyncThunk<
    Order,
    AddCustomListToOrderParams,
    ThunkConfig<string>
>(
    'customList/addCustomListToOrder',
    async ({ listId, orderId, listCount = 1 }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.post<Order>(
                `/v1/custom-lists/${listId}/order/${orderId}`,
                { listCount },
            );

            return response.data;
        } catch (e) {
            return rejectWithValue(String(getApiErrorMessage(e)));
        }
    },
);
